/** @file slotPrompt: the "ask the agent to draw this" text for one slot (size, pivot, view, band). */
import type { ArtSlot } from './artTypes';

/** One paragraph an agent can act on: the slot key, size, joint pixel, view (when known), band and twin note. */
export function slotPrompt(slot: ArtSlot): string {
  const [w, h] = slot.size;
  const view = slot.view === undefined
    ? 'its slot view (see slots)'
    : `body facing ${slot.view.bodyAzimuthDeg} degrees (${slot.direction}), camera ${slot.view.elevationDeg} degrees above`;
  const parts = [
    `Draw slot ${slot.key} (${slot.drawable}, entry ${slot.entry}, tile ${slot.tile}): ${w}x${h} pixels,`,
    `joint at pixel (${slot.pivot[0]}, ${slot.pivot[1]}), ${view}, band ${slot.band}.`,
  ];
  if (slot.mirroredFrom !== undefined) parts.push(`It repeats ${slot.mirroredFrom} flipped; reuse that image if it fits.`);
  parts.push(`Then fill it with slot.fill { slot: '${slot.key}', image } and run lint.`);
  return parts.join(' ');
}
